var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-svg-icons",
    transform: "translate(-40.000000, -330.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "support",
    transform: "translate(2.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8125,0 C19.3200364,0 20.5569858,1.18088098 20.6465437,2.66651371 L20.6517355,2.83923548 L20.6517355,12.0025608 C20.6517355,13.5100971 19.4706207,14.7470466 17.9851958,14.8366045 L17.8125,14.8417963 L8.8049703,14.8417963 L2.82915162,19 L2.82915162,14.8417963 C1.32598494,14.8364555 0.09434024,13.6572469 0.00516925655,12.1748969 L8.8817842e-14,12.0025608 L8.8817842e-14,2.83923548 C8.8817842e-14,1.33145635 1.18111476,0.0947316972 2.66653969,0.00519074801 L2.83923548,0 L17.8125,0 Z M10.7959098,10.5685553 L9.45139582,10.5685553 L9.45139582,11.9130693 L10.7959098,11.9130693 L10.7959098,10.5685553 Z M10.1236528,2.45665401 C8.69786733,2.45665401 7.52781943,3.57186401 7.43992489,4.97586824 L7.43462477,5.14568207 L8.7791388,5.14568207 C8.7791388,4.4042736 9.38224437,3.80116804 10.1236528,3.80116804 C10.8650613,3.80116804 11.4681669,4.4042736 11.4681669,5.14568207 C11.4681669,5.47977541 11.3491432,5.79135077 11.1303301,6.03701413 L11.0304995,6.13813649 L9.45139582,7.58348907 L9.45139582,9.22404129 L10.7959098,9.22404129 L10.7959098,8.17556545 L11.9382216,7.13006574 C12.4940591,6.62167137 12.8126809,5.89829481 12.8126809,5.14568207 C12.8126809,3.66286514 11.6064698,2.45665401 10.1236528,2.45665401 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.1b6a15beee9c921c78f48c83b58baff8.svg";
export { ForwardRef as ReactComponent };